<template>
  <div class="form-group">
    <label for="name">{{ $t("message.name") | capitalize }}</label>
    <input
      class="form-control"
      v-model.trim="localName"
      type="text"
      placeholder
      id="name"
      required
      minlength="2"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    localName: {
      get() {
        return this.value;
      },
      set(localName) {
        this.$emit("input", localName);
      }
    }
  },
  watch: {
    localName: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  }
};
</script>
